import type { TFunction } from 'i18next';
import type { TDurationInMinutes } from 'infrastructure/hooks/rpm/assign-tool/use-set-assign-patient';

export const getAssignMenuItems = (
  t: TFunction,
  onItemClick: (duration: TDurationInMinutes) => void,
) => [
  {
    label: t('labels.assignTimeFrame'),
    key: '0',
    dataItem: 'label',
  },
  {
    label: t('labels.oneHour'),
    key: '1',
    onClick: () => onItemClick(60),
  },
  {
    label: t('labels.twoHours'),
    'data-cy': 'dropdown-edit-item',
    key: '2',
    onClick: () => onItemClick(120),
  },
  {
    label: t('labels.threeHours'),
    'data-cy': 'dropdown-edit-item',
    key: '3',
    onClick: () => onItemClick(180),
  },
];
